/**
 * React hook that is used to mark the block wrapper element.
 * It provides all the necessary props like the class name.
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/packages/packages-block-editor/#useblockprops
 */
import { useBlockProps } from '@wordpress/block-editor';


export default function save({ attributes }) {
    const { images, layout, spacing, columns, enableLightbox } = attributes;
    return (
        <div
            { ...useBlockProps.save({
                className: `custom-gallery-frontend ${layout}`,
                style: {
                   '--row-gap': `${spacing}px`,
                     '--column-gap': `${spacing}px`,
                    columnCount: layout === 'masonry' ? columns : undefined,
                    gridTemplateColumns: layout === 'grid' ? `repeat(${columns}, 1fr)` : undefined
                }
            }) }
        >
           {images?.length &&
            images.map((img) => (
                <div key={img.id} className="gallery-img">
                    {enableLightbox ? (
                        <a href={img.url} data-fslightbox="gallery">
                            <img src={img.url} alt={img.alt} />
                        </a>
                    ) : (
                        <img src={img.url} alt={img.alt} />
                    )}
        </div>
    ))
}
        </div>
    );
}
